import React from "react";
import * as constants from '../constants';
import CPSettingSize from "../../../../UI/Settings/CPSettingSize";
import CPSettingToggle from "../../../../UI/Settings/CPSettingToggle";

const CardViewGrid = ({settings, onChange}) => {
    if (!settings) {
        return null;
    }

    return (
        <>
            <CPSettingSize
                name={constants.SCHEDULE_GRID_CARD_HIEGHT}
                label="Высота карточек в виде 'Сеткой'"
                eventValue={settings?.[constants.SCHEDULE_GRID_CARD_HIEGHT]}
                defaultValue={settings?.[constants.SCHEDULE_GRID_CARD_HIEGHT] ?? '6px'}
                hint="Пикселей в минуте"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_GRID_SHOW_MEMBERS_PHOTO}
                isChecked={settings?.[constants.SCHEDULE_GRID_SHOW_MEMBERS_PHOTO]}
                label="Показывать фотографии участников"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_GRID_SHOW_MEMBERS_NAME}
                isChecked={settings?.[constants.SCHEDULE_GRID_SHOW_MEMBERS_NAME]}
                label="Показывать имена участников"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_GRID_SHOW_PARTICIPATION_TYPE}
                isChecked={settings?.[constants.SCHEDULE_GRID_SHOW_PARTICIPATION_TYPE]}
                label="Показывать формат"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_GRID_SHOW_STATUS}
                isChecked={settings?.[constants.SCHEDULE_GRID_SHOW_STATUS]}
                label="Показывать статус"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_GRID_ADD_TO_CALENDAR}
                isChecked={settings?.[constants.SCHEDULE_GRID_ADD_TO_CALENDAR]}
                label="Показывать кнопку 'Добавить в календарь'"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_GRID_STRIPES}
                isChecked={settings?.[constants.SCHEDULE_GRID_STRIPES]}
                label="Показывать горизонтальные полоски у сетки"
                onChange={onChange}
            />
        </>
    );
};

export default CardViewGrid;
